module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "md-mask"
  }, [_c('div', {
    staticClass: "md-container"
  }, [_c('div', {
    staticClass: "md-dialog-header"
  }, [_c('div', {
    staticClass: "md-header-content"
  }, [_c('div', {
    staticClass: "icon-pill"
  }, [_c('svg', {
    staticStyle: {
      "width": "16px",
      "height": "16px"
    },
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 20h9"
    }
  }), _c('path', {
    attrs: {
      "d": "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
    }
  })])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Feedback Settings")]), _vm._v(" "), _c('p', {
    staticClass: "md-subtitle"
  }, [_vm._v("Runner: " + _vm._s(_vm.runnerName))])])]), _vm._v(" "), _c('button', {
    staticClass: "md-close-btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "md-dialog-body"
  }, [_c('div', {
    staticClass: "md-setting-row"
  }, [_vm._m(0), _vm._v(" "), _c('lv-toggle', {
    on: {
      "change": _vm.toggleChanged
    },
    model: {
      value: (_vm.enabled),
      callback: function($$v) {
        _vm.enabled = $$v
      },
      expression: "enabled"
    }
  })], 1), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "md-error"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "md-dialog-footer"
  }, [_c('button', {
    staticClass: "md-ghost-btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "md-primary-btn",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v("\n        " + _vm._s(_vm.loading ? 'Saving...' : 'Save Settings') + "\n      ")])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "md-label"
  }, [_vm._v("Feedback Widget Enabled")]), _vm._v(" "), _c('div', {
    staticClass: "md-desc"
  }, [_vm._v("Allows advanced crash and feedback reporting for this user.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-156fd9b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/BugseeSettingsModal.vue
// module id = 1622
// module chunks = 2